/**
 * Periodicity for planning units:
 *   - Mailings running;
 *   - Creation of BRS tasks by BRS task templates;
 *   - Creation of manual documents by manual document templates;
 *   - Creation of projects by project templates;
 */
export enum TemplateEntityPeriodicityEnum {
  /** No periodicity for this template (still can create entity by this template manually) */
  NONE = 'NONE',
  /** Run planning unit once, on a specific date */
  ONCE = 'ONCE',
  /** Create entity by corresponding template entity every work day */
  ON_WORK_DAYS = 'ON_WORK_DAYS',
  /** Create entity by corresponding template entity every day */
  DAILY = 'DAILY',
  /** Create entity by corresponding template entity every week */
  WEEKLY = 'WEEKLY',
  /** Create entity by corresponding template entity every month */
  MONTHLY = 'MONTHLY',
  /** Create entity by corresponding template entity every quarter */
  QUARTERLY = 'QUARTERLY',
  /** Create entity by corresponding template entity every year */
  ANNUALLY = 'ANNUALLY',
}
